export default __webpack_public_path__ + "static/media/sci-tech-news-logo_6.12a9be19.png";